/** `Vertical` = bottom-edge handle, height only. `Diagonal` = corner handle, ratio-preserving. */
export enum ResizeType {
  None = 'none',
  Vertical = 'vertical',
  Diagonal = 'diagonal',
}

export type ResizeTypeInput = ResizeType | readonly ResizeType[];

export const CORNER_AND_VERTICAL_RESIZE: readonly ResizeType[] = [ResizeType.Diagonal, ResizeType.Vertical];

export const normalizeResizeTypes = (resizeType: ResizeTypeInput, isDiagonalResizeEnabled: boolean): ResizeType[] => {
  if (resizeType === ResizeType.None) return [];

  const types = Array.isArray(resizeType) ? resizeType : [resizeType];
  const unique = [...new Set(types)];

  if (!isDiagonalResizeEnabled) {
    return unique.filter((type) => type !== ResizeType.Diagonal);
  }

  return unique;
};
